// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"214":"fe795995","899":"65928239","920":"0d1640a7","958":"a2011f0f"}[chunkId] + ".chunk.css";
};